import { render, staticRenderFns } from "./LawyerJobInfoTab.vue?vue&type=template&id=50bf5752&scoped=true&"
import script from "./LawyerJobInfoTab.vue?vue&type=script&lang=js&"
export * from "./LawyerJobInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./LawyerJobInfoTab.vue?vue&type=style&index=0&id=50bf5752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bf5752",
  null
  
)

export default component.exports